// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["src_components_ids-data-grid_demos_index_yaml"], () => (__webpack_require__("./src/components/ids-demo-app/demos/index.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
